import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext } from 'react';
import { OrderItem } from 'src/admin-entity/interface/order/order-item.interface';

type ContextType = {
    isWithdrawModalOpen: boolean;
    setIsWithdrawModalOpen: Dispatch<SetStateAction<boolean>>;
    isWithdrawModalOpenOld: boolean;
    setIsWithdrawModalOpenOld: Dispatch<SetStateAction<boolean>>;
    withdrawOrderItem: OrderItem;
    setWithdrawOrderItem: React.Dispatch<React.SetStateAction<OrderItem>>;
};

const OrderItemWithdrawContext = createContext<ContextType>(undefined);

export function OrderItemWithdrawContextProvider({ children }: { children: ReactNode }) {
    const [isWithdrawModalOpen, setIsWithdrawModalOpen] = React.useState(false);
    const [isWithdrawModalOpenOld, setIsWithdrawModalOpenOld] = React.useState(false);
    const [withdrawOrderItem, setWithdrawOrderItem] = React.useState<OrderItem>(undefined);

    return (
        <OrderItemWithdrawContext.Provider
            value={{
                isWithdrawModalOpen,
                setIsWithdrawModalOpen,
                isWithdrawModalOpenOld,
                setIsWithdrawModalOpenOld,
                withdrawOrderItem,
                setWithdrawOrderItem,
            }}
        >
            {children}
        </OrderItemWithdrawContext.Provider>
    );
}

export function useOrderItemWithdrawState(): ContextType {
    const state = useContext(OrderItemWithdrawContext);
    if (!state) throw new Error('OrderItemWithdrawContext Error');
    return state;
}
